import React from 'react';
import { Stack } from '@mui/material';
import { Body1 } from '@/components/@IntranetLibrary/Typography';
import IconButton from '@/components/@IntranetLibrary/Button/IconButton';
import { WordReplaceHistoryItem } from '@/hooks/apiHooks/wordReplace';
import Arrow2Icon from 'public/icons/arrow02.svg';
import { StyledHistoryItem, DeleteIcon } from './styled';

type HistoryItemProps = {
  history: WordReplaceHistoryItem;
  onDelete?: (history: WordReplaceHistoryItem) => void;
  isDeleting?: boolean;
  onClick?: (history: WordReplaceHistoryItem) => void;
  onHover?: (history: WordReplaceHistoryItem | null) => void;
};

/**
 * 단어 바꾸기 이력 아이템
 */
export default function HistoryItem({
  history,
  onDelete,
  isDeleting = false,
  onClick,
  onHover,
}: HistoryItemProps) {
  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete?.(history);
  };

  const handleClick = () => {
    onClick?.(history);
  };

  const handleMouseEnter = () => {
    onHover?.(history);
  };

  const handleMouseLeave = () => {
    onHover?.(null);
  };

  return (
    <StyledHistoryItem
      direction="row"
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Stack gap={'4px'} sx={{ overflow: 'hidden', minWidth: 0, flex: 1 }}>
        <Body1
          className={'ellipsis'}
          sx={{
            fontWeight: 400,
            color: 'var(--dk-text-secondary, #888D96)',
          }}
        >
          {history.original}
        </Body1>
        <Stack direction="row" gap={'4px'} sx={{ overflow: 'hidden' }}>
          <Arrow2Icon />
          <Body1
            className={'ellipsis'}
            sx={{ overflow: 'hidden', minWidth: 0, flex: 1 }}
          >
            {history.replaced}
          </Body1>
        </Stack>
      </Stack>
      <IconButton
        size="small"
        onClick={handleDelete}
        disabled={isDeleting}
        sx={{ ':hover': { backgroundColor: 'transparent' } }}
      >
        {!isDeleting && <DeleteIcon />}
      </IconButton>
    </StyledHistoryItem>
  );
}
